"use client"

// if you are planing to use it in the component which is not marker with use client directive this is a must
import Link, { LinkProps } from "next/link"
import { usePathname } from "next/navigation"

interface ActiveLinkProps {
  children: React.ReactNode
  href: string
  className: string
  activeClassName: string
}

const ActiveLink = ({
  children,
  href,
  className,
  activeClassName,
}: ActiveLinkProps) => {
  const pathName = usePathname()

  const isActive = pathName === href
  const linkClassName = isActive ? activeClassName : className

  return (
    <Link href={href} className={linkClassName}>
      {children}
    </Link>
  )
}

export default ActiveLink
